import * as Yup from 'yup';

export const groupSchema = Yup.object().shape({
  name: Yup.string()
    .required("Обов'язкове поле")
    .matches(/^[a-zA-Zа-яА-ЯёЁіІїЇєЄ\s'-]+$/, 'Тільки літери та допустимі символи')
    .trim(),
  isClub: Yup.boolean(),
  locationID: Yup.number()
    .required("Обов'язкове поле")
    .integer('Повинно бути ціле число')
    .positive('Повинно бути додатнє число'),
  clientIDs: Yup.array().of(Yup.number().positive('Клієнта не знайдено')).nullable(),
});
